import config from "config/config";
import { authService } from "./authService";
import {
    CreateNewProductPlanPayload,
    UpdateNewProductPlanPayload,
    NewProductPlanFilters,
} from "redux/Ldb/types/newProductPlanTypes";

export const newProductPlanService = {
    getSingleNewProductPlan,
    getNewProductPlans,
    createNewProductPlan,
    updateNewProductPlan,
    pinNewProductPlan,
    unpinNewProductPlan,
    cancelNewProductPlan,
    deleteNewProductPlan,
};

async function getSingleNewProductPlan(id: string) {
    try {
        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan/${id}`,
            {
                method: "GET",
            }
        );
        return res;
    } catch (error) {
        console.error("Error fetching single new product plan:", error);
        throw error;
    }
}

async function getNewProductPlans(filters: NewProductPlanFilters) {
    try {
        const queryParams = new URLSearchParams();

        if (filters.search) queryParams.append("search", filters.search);
        if (filters.productId) queryParams.append("productId", filters.productId);
        if (filters.launchDateFrom) queryParams.append("launchDateFrom", filters.launchDateFrom);
        if (filters.launchDateTo) queryParams.append("launchDateTo", filters.launchDateTo);
        if (filters.growthRateMin)
            queryParams.append("growthRateMin", filters.growthRateMin.toString());
        if (filters.growthRateMax)
            queryParams.append("growthRateMax", filters.growthRateMax.toString());
        if (filters.page) queryParams.append("page", filters.page.toString());
        if (filters.limit) queryParams.append("limit", filters.limit.toString());
        if (filters.sortBy) queryParams.append("sortBy", filters.sortBy);
        if (filters.sortDirection) queryParams.append("sortDirection", filters.sortDirection);
        if (filters.status) queryParams.append("status", filters.status);

        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan?${queryParams.toString()}`,
            {
                method: "GET",
            }
        );
        return res;
    } catch (error) {
        console.error("Error fetching new product plans:", error);
        throw error;
    }
}

async function createNewProductPlan(data: CreateNewProductPlanPayload) {
    try {
        const res = await authService.apiGate(`${config.API_URL}/api/v1/ldb/new-product-plan`, {
            method: "POST",
            body: JSON.stringify(data),
        });
        return res;
    } catch (error) {
        console.error("Error creating new product plan:", error);
        throw error;
    }
}

async function updateNewProductPlan(data: UpdateNewProductPlanPayload) {
    try {
        const res = await authService.apiGate(`${config.API_URL}/api/v1/ldb/new-product-plan`, {
            method: "PUT",
            body: JSON.stringify(data),
        });
        return res;
    } catch (error) {
        console.error("Error updating new product plan:", error);
        throw error;
    }
}

async function pinNewProductPlan(id: string) {
    try {
        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan/${id}/pin`,
            {
                method: "PUT",
            }
        );
        return res;
    } catch (error) {
        console.error("Error pinning new product plan:", error);
        throw error;
    }
}

async function unpinNewProductPlan(id: string) {
    try {
        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan/${id}/unpin`,
            {
                method: "PUT",
            }
        );
        return res;
    } catch (error) {
        console.error("Error unpinning new product plan:", error);
        throw error;
    }
}

async function cancelNewProductPlan(id: string) {
    try {
        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan/${id}/cancel`,
            {
                method: "PUT",
            }
        );
        return res;
    } catch (error) {
        console.error("Error canceling new product plan:", error);
        throw error;
    }
}

async function deleteNewProductPlan(id: string) {
    try {
        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/new-product-plan/${id}`,
            {
                method: "DELETE",
            }
        );
        return res;
    } catch (error) {
        console.error("Error deleting new product plan:", error);
        throw error;
    }
}
